import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import swal from "sweetalert";
import axios from "axios";
import { toast } from "react-toastify";

function Login() {
  const [admin, setAdmin] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const referral_API = async () => {
    try {
      let responceRight = await API.post("/AdminLogin_1", {
        userid: admin,
        password: password,
      });
      //console.log("login", responceRight.data.data);
      if (responceRight.data.data == "success") {
        // alert('Login successfully')
        sessionStorage.setItem(
          "user",
          JSON.stringify({
            username: admin,
            password: password,
          }),
        );
        navigate("/OPT_Confirm");
        // OPT_Confirm()
      } else {
        swal({
          title: "Login error..!",
          text: responceRight.data.data,
          icon: "error",
          button: "OK",
        });
      }
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };

  useEffect(() => {
    sessionStorage.clear();
  });

  return (
    <div>
      <form id="Form1">
        <div class="wrapper-page2">
          <div class="wrapper-page mtip_up">
            <center>
              <img
                src="/assets/images/logo.svg"
                style={{ width: "150px", paddingTop: "30px" }}
              />
              <br />
              <br />
            </center>
            <div
              class="panel panel-color panel-primary panel-pages"
              style={{
                border: "1px solid rgb(0 0 0 / 76%)",
                boxShadow: "0px 2px 6px 4px #00000078",
              }}
            >
              <p class="heddlogin">Admin Login</p>
              <div id="Panel1" ng-show="panel1">
                <div class="panel-body">
                  <div class="form-horizontal m-t-20">
                    <div class="form-group">
                      <div class="col-xs-12">
                        <input
                          type="text"
                          class="form-control input-lg"
                          onChange={(e) => setAdmin(e.target.value)}
                          placeholder="User ID"
                          maxLength={50}
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="col-xs-12">
                        <input
                          type="password"
                          class="form-control input-lg"
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Password"
                          maxLength={50}
                        />
                      </div>
                    </div>
                    <div class="form-group text-center m-t-40">
                      <div class="col-xs-12">
                        <a
                          type="button"
                          class="btn btn-primary btn-lg w-lg"
                          onClick={() => referral_API()}
                        >
                          Sign IN
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Login;
